/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { balanceGraphPlan } from '../fn/calc-results/balance-graph-plan';
import { BalanceGraphPlan$Params } from '../fn/calc-results/balance-graph-plan';
import { BackendCalculationResultDto } from '../models/backend-calculation-result-dto';
import { cashFlowGraphPlan } from '../fn/calc-results/cash-flow-graph-plan';
import { CashFlowGraphPlan$Params } from '../fn/calc-results/cash-flow-graph-plan';
import { investorReportGraph } from '../fn/calc-results/investor-report-graph';
import { InvestorReportGraph$Params } from '../fn/calc-results/investor-report-graph';
import { profitAndLossGraphPlan } from '../fn/calc-results/profit-and-loss-graph-plan';
import { ProfitAndLossGraphPlan$Params } from '../fn/calc-results/profit-and-loss-graph-plan';
import { projectCalculationsBalanceDataRetrieve } from '../fn/calc-results/project-calculations-balance-data-retrieve';
import { ProjectCalculationsBalanceDataRetrieve$Params } from '../fn/calc-results/project-calculations-balance-data-retrieve';
import { projectCalculationsCalculationResultsRetrieve } from '../fn/calc-results/project-calculations-calculation-results-retrieve';
import { ProjectCalculationsCalculationResultsRetrieve$Params } from '../fn/calc-results/project-calculations-calculation-results-retrieve';
import { projectCalculationsCashFlowPlanDataRetrieve } from '../fn/calc-results/project-calculations-cash-flow-plan-data-retrieve';
import { ProjectCalculationsCashFlowPlanDataRetrieve$Params } from '../fn/calc-results/project-calculations-cash-flow-plan-data-retrieve';
import { projectCalculationsInvestorReportRetrieve } from '../fn/calc-results/project-calculations-investor-report-retrieve';
import { ProjectCalculationsInvestorReportRetrieve$Params } from '../fn/calc-results/project-calculations-investor-report-retrieve';
import { projectCalculationsProfitAndLossPlanDataRetrieve } from '../fn/calc-results/project-calculations-profit-and-loss-plan-data-retrieve';
import { ProjectCalculationsProfitAndLossPlanDataRetrieve$Params } from '../fn/calc-results/project-calculations-profit-and-loss-plan-data-retrieve';
import { projectCalculationsResultFinAnalysDataRetrieve } from '../fn/calc-results/project-calculations-result-fin-analys-data-retrieve';
import { ProjectCalculationsResultFinAnalysDataRetrieve$Params } from '../fn/calc-results/project-calculations-result-fin-analys-data-retrieve';
import { projectCalculationsSalesPlanRetrieve } from '../fn/calc-results/project-calculations-sales-plan-retrieve';
import { ProjectCalculationsSalesPlanRetrieve$Params } from '../fn/calc-results/project-calculations-sales-plan-retrieve';
import { projectCalculationsScenarioVentureFundsRetrieve } from '../fn/calc-results/project-calculations-scenario-venture-funds-retrieve';
import { ProjectCalculationsScenarioVentureFundsRetrieve$Params } from '../fn/calc-results/project-calculations-scenario-venture-funds-retrieve';
import { projectCalculationsTamSomSamPamChartRetrieve } from '../fn/calc-results/project-calculations-tam-som-sam-pam-chart-retrieve';
import { ProjectCalculationsTamSomSamPamChartRetrieve$Params } from '../fn/calc-results/project-calculations-tam-som-sam-pam-chart-retrieve';
import { resultFinancialAnalysisGraph } from '../fn/calc-results/result-financial-analysis-graph';
import { ResultFinancialAnalysisGraph$Params } from '../fn/calc-results/result-financial-analysis-graph';
import { salesPlanGraph } from '../fn/calc-results/sales-plan-graph';
import { SalesPlanGraph$Params } from '../fn/calc-results/sales-plan-graph';
import { salesPlanProducts } from '../fn/calc-results/sales-plan-products';
import { SalesPlanProducts$Params } from '../fn/calc-results/sales-plan-products';

@Injectable({ providedIn: 'root' })
export class BackendApiCalcResultsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `projectCalculationsBalanceDataRetrieve()` */
  static readonly ProjectCalculationsBalanceDataRetrievePath = '/api/project_calculations/balance_data/{id}/';

  /**
   * Планирование баланса.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectCalculationsBalanceDataRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCalculationsBalanceDataRetrieve$Response(
    params: ProjectCalculationsBalanceDataRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return projectCalculationsBalanceDataRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Планирование баланса.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectCalculationsBalanceDataRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCalculationsBalanceDataRetrieve(
    params: ProjectCalculationsBalanceDataRetrieve$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.projectCalculationsBalanceDataRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `balanceGraphPlan()` */
  static readonly BalanceGraphPlanPath = '/api/project_calculations/balance_data/graph/{id}/';

  /**
   * Получает данные для графика баланса для выбранного сценария. Ответ содержит категории (даты) и серии данных по показателям баланса. Данные могут быть сгруппированы по месяцам или годам с поддержкой пагинации.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `balanceGraphPlan()` instead.
   *
   * This method doesn't expect any request body.
   */
  balanceGraphPlan$Response(
    params: BalanceGraphPlan$Params,
    context?: HttpContext,
  ): Observable<
    BakendHttpResponse<{
      /**
       * Список периодов (месяцы или годы).
       */
      category: Array<string>;
      series: Array<{
        data: Array<number>;
        title: string;
        code: string;
      }>;
    }>
  > {
    return balanceGraphPlan(this.http, this.rootUrl, params, context);
  }

  /**
   * Получает данные для графика баланса для выбранного сценария. Ответ содержит категории (даты) и серии данных по показателям баланса. Данные могут быть сгруппированы по месяцам или годам с поддержкой пагинации.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `balanceGraphPlan$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  balanceGraphPlan(
    params: BalanceGraphPlan$Params,
    context?: HttpContext,
  ): Observable<{
    /**
     * Список периодов (месяцы или годы).
     */
    category: Array<string>;
    series: Array<{
      data: Array<number>;
      title: string;
      code: string;
    }>;
  }> {
    return this.balanceGraphPlan$Response(params, context).pipe(
      map(
        (
          r: BakendHttpResponse<{
            /**
             * Список периодов (месяцы или годы).
             */
            category: Array<string>;
            series: Array<{
              data: Array<number>;
              title: string;
              code: string;
            }>;
          }>,
        ): {
          /**
           * Список периодов (месяцы или годы).
           */
          category: Array<string>;
          series: Array<{
            data: Array<number>;
            title: string;
            code: string;
          }>;
        } => r.body,
      ),
    );
  }

  /** Path part for operation `projectCalculationsCalculationResultsRetrieve()` */
  static readonly ProjectCalculationsCalculationResultsRetrievePath =
    '/api/project_calculations/calculation_results/{id}/';

  /**
   * create and view calculation results
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectCalculationsCalculationResultsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCalculationsCalculationResultsRetrieve$Response(
    params: ProjectCalculationsCalculationResultsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCalculationResultDto>> {
    return projectCalculationsCalculationResultsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * create and view calculation results
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectCalculationsCalculationResultsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCalculationsCalculationResultsRetrieve(
    params: ProjectCalculationsCalculationResultsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendCalculationResultDto> {
    return this.projectCalculationsCalculationResultsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCalculationResultDto>): BackendCalculationResultDto => r.body),
    );
  }

  /** Path part for operation `projectCalculationsCashFlowPlanDataRetrieve()` */
  static readonly ProjectCalculationsCashFlowPlanDataRetrievePath =
    '/api/project_calculations/cash_flow_plan_data/{id}/';

  /**
   * План движения ден. средств.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectCalculationsCashFlowPlanDataRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCalculationsCashFlowPlanDataRetrieve$Response(
    params: ProjectCalculationsCashFlowPlanDataRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return projectCalculationsCashFlowPlanDataRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * План движения ден. средств.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectCalculationsCashFlowPlanDataRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCalculationsCashFlowPlanDataRetrieve(
    params: ProjectCalculationsCashFlowPlanDataRetrieve$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.projectCalculationsCashFlowPlanDataRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `cashFlowGraphPlan()` */
  static readonly CashFlowGraphPlanPath = '/api/project_calculations/cash_flow_plan_data/graph/{id}/';

  /**
   * Получает данные для графика плана движения денежных средств для указанного сценария. Возвращает категории (даты) и серии данных по метрикам. Данные агрегируются по указанному периоду (месяц, год) с поддержкой пагинации.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cashFlowGraphPlan()` instead.
   *
   * This method doesn't expect any request body.
   */
  cashFlowGraphPlan$Response(
    params: CashFlowGraphPlan$Params,
    context?: HttpContext,
  ): Observable<
    BakendHttpResponse<{
      /**
       * Список периодов (месяцы или годы).
       */
      category: Array<string>;
      series: Array<{
        data: Array<number>;
        title: string;
        code: string;
      }>;
    }>
  > {
    return cashFlowGraphPlan(this.http, this.rootUrl, params, context);
  }

  /**
   * Получает данные для графика плана движения денежных средств для указанного сценария. Возвращает категории (даты) и серии данных по метрикам. Данные агрегируются по указанному периоду (месяц, год) с поддержкой пагинации.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `cashFlowGraphPlan$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  cashFlowGraphPlan(
    params: CashFlowGraphPlan$Params,
    context?: HttpContext,
  ): Observable<{
    /**
     * Список периодов (месяцы или годы).
     */
    category: Array<string>;
    series: Array<{
      data: Array<number>;
      title: string;
      code: string;
    }>;
  }> {
    return this.cashFlowGraphPlan$Response(params, context).pipe(
      map(
        (
          r: BakendHttpResponse<{
            /**
             * Список периодов (месяцы или годы).
             */
            category: Array<string>;
            series: Array<{
              data: Array<number>;
              title: string;
              code: string;
            }>;
          }>,
        ): {
          /**
           * Список периодов (месяцы или годы).
           */
          category: Array<string>;
          series: Array<{
            data: Array<number>;
            title: string;
            code: string;
          }>;
        } => r.body,
      ),
    );
  }

  /** Path part for operation `projectCalculationsInvestorReportRetrieve()` */
  static readonly ProjectCalculationsInvestorReportRetrievePath =
    '/api/project_calculations/investor-report/{scenario_pk}/';

  /**
   * Получить отчет инвестора.
   *
   * Отчет инвестора.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectCalculationsInvestorReportRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCalculationsInvestorReportRetrieve$Response(
    params: ProjectCalculationsInvestorReportRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return projectCalculationsInvestorReportRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Получить отчет инвестора.
   *
   * Отчет инвестора.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectCalculationsInvestorReportRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCalculationsInvestorReportRetrieve(
    params: ProjectCalculationsInvestorReportRetrieve$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.projectCalculationsInvestorReportRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `investorReportGraph()` */
  static readonly InvestorReportGraphPath = '/api/project_calculations/investor-report/graph/{scenario_pk}/';

  /**
   * Получает данные для графика отчета инвестора для выбранного сценария и венчурного фонда. Ответ содержит категории (даты) и серии данных по показателям отчета инвестора. Данные могут быть сгруппированы по месяцам или годам с поддержкой пагинации.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `investorReportGraph()` instead.
   *
   * This method doesn't expect any request body.
   */
  investorReportGraph$Response(
    params: InvestorReportGraph$Params,
    context?: HttpContext,
  ): Observable<
    BakendHttpResponse<{
      /**
       * Список периодов (месяцы или годы).
       */
      category: Array<string>;
      series: Array<{
        data: Array<number>;
        title: string;
        code: string;
      }>;
    }>
  > {
    return investorReportGraph(this.http, this.rootUrl, params, context);
  }

  /**
   * Получает данные для графика отчета инвестора для выбранного сценария и венчурного фонда. Ответ содержит категории (даты) и серии данных по показателям отчета инвестора. Данные могут быть сгруппированы по месяцам или годам с поддержкой пагинации.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `investorReportGraph$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  investorReportGraph(
    params: InvestorReportGraph$Params,
    context?: HttpContext,
  ): Observable<{
    /**
     * Список периодов (месяцы или годы).
     */
    category: Array<string>;
    series: Array<{
      data: Array<number>;
      title: string;
      code: string;
    }>;
  }> {
    return this.investorReportGraph$Response(params, context).pipe(
      map(
        (
          r: BakendHttpResponse<{
            /**
             * Список периодов (месяцы или годы).
             */
            category: Array<string>;
            series: Array<{
              data: Array<number>;
              title: string;
              code: string;
            }>;
          }>,
        ): {
          /**
           * Список периодов (месяцы или годы).
           */
          category: Array<string>;
          series: Array<{
            data: Array<number>;
            title: string;
            code: string;
          }>;
        } => r.body,
      ),
    );
  }

  /** Path part for operation `projectCalculationsProfitAndLossPlanDataRetrieve()` */
  static readonly ProjectCalculationsProfitAndLossPlanDataRetrievePath =
    '/api/project_calculations/profit_and_loss_plan_data/{id}/';

  /**
   * План прибылей и убытков.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectCalculationsProfitAndLossPlanDataRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCalculationsProfitAndLossPlanDataRetrieve$Response(
    params: ProjectCalculationsProfitAndLossPlanDataRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return projectCalculationsProfitAndLossPlanDataRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * План прибылей и убытков.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectCalculationsProfitAndLossPlanDataRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCalculationsProfitAndLossPlanDataRetrieve(
    params: ProjectCalculationsProfitAndLossPlanDataRetrieve$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.projectCalculationsProfitAndLossPlanDataRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `profitAndLossGraphPlan()` */
  static readonly ProfitAndLossGraphPlanPath = '/api/project_calculations/profit_and_loss_plan_data/graph/{id}/';

  /**
   * Получает данные для графика плана прибылей и убытков для указанного сценария. Возвращает категории (даты) и серии данных для метрик, таких как выручка, прибыль и затраты. Данные агрегируются по указанному периоду (месяц, год) с поддержкой пагинации.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `profitAndLossGraphPlan()` instead.
   *
   * This method doesn't expect any request body.
   */
  profitAndLossGraphPlan$Response(
    params: ProfitAndLossGraphPlan$Params,
    context?: HttpContext,
  ): Observable<
    BakendHttpResponse<{
      /**
       * Список дат, соответствующих периодам.
       */
      category: Array<string>;

      /**
       * Список серий данных, каждая из которых представляет метрику.
       */
      series: Array<{
        /**
         * Значения метрики для соответствующих дат.
         */
        data: Array<number>;

        /**
         * Название метрики (например, 'Выручка', 'Прибыль').
         */
        title: string;

        /**
         * Код метрики (например, 'revenue', 'profit').
         */
        code: string;
      }>;
    }>
  > {
    return profitAndLossGraphPlan(this.http, this.rootUrl, params, context);
  }

  /**
   * Получает данные для графика плана прибылей и убытков для указанного сценария. Возвращает категории (даты) и серии данных для метрик, таких как выручка, прибыль и затраты. Данные агрегируются по указанному периоду (месяц, год) с поддержкой пагинации.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `profitAndLossGraphPlan$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  profitAndLossGraphPlan(
    params: ProfitAndLossGraphPlan$Params,
    context?: HttpContext,
  ): Observable<{
    /**
     * Список дат, соответствующих периодам.
     */
    category: Array<string>;

    /**
     * Список серий данных, каждая из которых представляет метрику.
     */
    series: Array<{
      /**
       * Значения метрики для соответствующих дат.
       */
      data: Array<number>;

      /**
       * Название метрики (например, 'Выручка', 'Прибыль').
       */
      title: string;

      /**
       * Код метрики (например, 'revenue', 'profit').
       */
      code: string;
    }>;
  }> {
    return this.profitAndLossGraphPlan$Response(params, context).pipe(
      map(
        (
          r: BakendHttpResponse<{
            /**
             * Список дат, соответствующих периодам.
             */
            category: Array<string>;

            /**
             * Список серий данных, каждая из которых представляет метрику.
             */
            series: Array<{
              /**
               * Значения метрики для соответствующих дат.
               */
              data: Array<number>;

              /**
               * Название метрики (например, 'Выручка', 'Прибыль').
               */
              title: string;

              /**
               * Код метрики (например, 'revenue', 'profit').
               */
              code: string;
            }>;
          }>,
        ): {
          /**
           * Список дат, соответствующих периодам.
           */
          category: Array<string>;

          /**
           * Список серий данных, каждая из которых представляет метрику.
           */
          series: Array<{
            /**
             * Значения метрики для соответствующих дат.
             */
            data: Array<number>;

            /**
             * Название метрики (например, 'Выручка', 'Прибыль').
             */
            title: string;

            /**
             * Код метрики (например, 'revenue', 'profit').
             */
            code: string;
          }>;
        } => r.body,
      ),
    );
  }

  /** Path part for operation `projectCalculationsResultFinAnalysDataRetrieve()` */
  static readonly ProjectCalculationsResultFinAnalysDataRetrievePath =
    '/api/project_calculations/result_fin_analys_data/{id}/';

  /**
   * Результаты фин. анализа.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectCalculationsResultFinAnalysDataRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCalculationsResultFinAnalysDataRetrieve$Response(
    params: ProjectCalculationsResultFinAnalysDataRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return projectCalculationsResultFinAnalysDataRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Результаты фин. анализа.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectCalculationsResultFinAnalysDataRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCalculationsResultFinAnalysDataRetrieve(
    params: ProjectCalculationsResultFinAnalysDataRetrieve$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.projectCalculationsResultFinAnalysDataRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `resultFinancialAnalysisGraph()` */
  static readonly ResultFinancialAnalysisGraphPath = '/api/project_calculations/result_fin_analys_data/graph/{id}/';

  /**
   * Получает данные для графика результатов финансового анализа для выбранного сценария. Ответ содержит категории (даты) и серии данных по показателям финансового анализа. Данные могут быть сгруппированы по месяцам или годам с поддержкой пагинации.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resultFinancialAnalysisGraph()` instead.
   *
   * This method doesn't expect any request body.
   */
  resultFinancialAnalysisGraph$Response(
    params: ResultFinancialAnalysisGraph$Params,
    context?: HttpContext,
  ): Observable<
    BakendHttpResponse<{
      /**
       * Список периодов (месяцы или годы).
       */
      category: Array<string>;
      series: Array<{
        data: Array<number>;
        title: string;
        code: string;
      }>;
    }>
  > {
    return resultFinancialAnalysisGraph(this.http, this.rootUrl, params, context);
  }

  /**
   * Получает данные для графика результатов финансового анализа для выбранного сценария. Ответ содержит категории (даты) и серии данных по показателям финансового анализа. Данные могут быть сгруппированы по месяцам или годам с поддержкой пагинации.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resultFinancialAnalysisGraph$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resultFinancialAnalysisGraph(
    params: ResultFinancialAnalysisGraph$Params,
    context?: HttpContext,
  ): Observable<{
    /**
     * Список периодов (месяцы или годы).
     */
    category: Array<string>;
    series: Array<{
      data: Array<number>;
      title: string;
      code: string;
    }>;
  }> {
    return this.resultFinancialAnalysisGraph$Response(params, context).pipe(
      map(
        (
          r: BakendHttpResponse<{
            /**
             * Список периодов (месяцы или годы).
             */
            category: Array<string>;
            series: Array<{
              data: Array<number>;
              title: string;
              code: string;
            }>;
          }>,
        ): {
          /**
           * Список периодов (месяцы или годы).
           */
          category: Array<string>;
          series: Array<{
            data: Array<number>;
            title: string;
            code: string;
          }>;
        } => r.body,
      ),
    );
  }

  /** Path part for operation `projectCalculationsSalesPlanRetrieve()` */
  static readonly ProjectCalculationsSalesPlanRetrievePath = '/api/project_calculations/sales_plan/{id}/';

  /**
   * План продаж.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectCalculationsSalesPlanRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCalculationsSalesPlanRetrieve$Response(
    params: ProjectCalculationsSalesPlanRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return projectCalculationsSalesPlanRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * План продаж.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectCalculationsSalesPlanRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCalculationsSalesPlanRetrieve(
    params: ProjectCalculationsSalesPlanRetrieve$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.projectCalculationsSalesPlanRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `salesPlanGraph()` */
  static readonly SalesPlanGraphPath = '/api/project_calculations/sales_plan/graph/{id}/';

  /**
   * Получает данные для графика плана продаж по выбранному продукту и общему плану продаж в рамках сценария.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesPlanGraph()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesPlanGraph$Response(
    params: SalesPlanGraph$Params,
    context?: HttpContext,
  ): Observable<
    BakendHttpResponse<{
      category: Array<string>;
      series: Array<{
        data: Array<number>;
        title: string;
        code: string;
      }>;
    }>
  > {
    return salesPlanGraph(this.http, this.rootUrl, params, context);
  }

  /**
   * Получает данные для графика плана продаж по выбранному продукту и общему плану продаж в рамках сценария.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesPlanGraph$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesPlanGraph(
    params: SalesPlanGraph$Params,
    context?: HttpContext,
  ): Observable<{
    category: Array<string>;
    series: Array<{
      data: Array<number>;
      title: string;
      code: string;
    }>;
  }> {
    return this.salesPlanGraph$Response(params, context).pipe(
      map(
        (
          r: BakendHttpResponse<{
            category: Array<string>;
            series: Array<{
              data: Array<number>;
              title: string;
              code: string;
            }>;
          }>,
        ): {
          category: Array<string>;
          series: Array<{
            data: Array<number>;
            title: string;
            code: string;
          }>;
        } => r.body,
      ),
    );
  }

  /** Path part for operation `salesPlanProducts()` */
  static readonly SalesPlanProductsPath = '/api/project_calculations/sales_plan/products/{id}/';

  /**
   * Возвращает уникальный список продуктов из плана продаж для выбранного сценария.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesPlanProducts()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesPlanProducts$Response(
    params: SalesPlanProducts$Params,
    context?: HttpContext,
  ): Observable<
    BakendHttpResponse<
      Array<{
        id: number;
        name: string;
      }>
    >
  > {
    return salesPlanProducts(this.http, this.rootUrl, params, context);
  }

  /**
   * Возвращает уникальный список продуктов из плана продаж для выбранного сценария.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesPlanProducts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesPlanProducts(
    params: SalesPlanProducts$Params,
    context?: HttpContext,
  ): Observable<
    Array<{
      id: number;
      name: string;
    }>
  > {
    return this.salesPlanProducts$Response(params, context).pipe(
      map(
        (
          r: BakendHttpResponse<
            Array<{
              id: number;
              name: string;
            }>
          >,
        ): Array<{
          id: number;
          name: string;
        }> => r.body,
      ),
    );
  }

  /** Path part for operation `projectCalculationsScenarioVentureFundsRetrieve()` */
  static readonly ProjectCalculationsScenarioVentureFundsRetrievePath =
    '/api/project_calculations/scenario/{scenario_pk}/venture-funds/';

  /**
   * Получить венчурные фонды для отчета инвестора.
   *
   * Получить венчурные фонды сценария
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectCalculationsScenarioVentureFundsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCalculationsScenarioVentureFundsRetrieve$Response(
    params: ProjectCalculationsScenarioVentureFundsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return projectCalculationsScenarioVentureFundsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Получить венчурные фонды для отчета инвестора.
   *
   * Получить венчурные фонды сценария
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectCalculationsScenarioVentureFundsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCalculationsScenarioVentureFundsRetrieve(
    params: ProjectCalculationsScenarioVentureFundsRetrieve$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.projectCalculationsScenarioVentureFundsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `projectCalculationsTamSomSamPamChartRetrieve()` */
  static readonly ProjectCalculationsTamSomSamPamChartRetrievePath =
    '/api/project_calculations/tam_som_sam_pam_chart/{id}/';

  /**
   * График ТамСамПамСом
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectCalculationsTamSomSamPamChartRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCalculationsTamSomSamPamChartRetrieve$Response(
    params: ProjectCalculationsTamSomSamPamChartRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return projectCalculationsTamSomSamPamChartRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * График ТамСамПамСом
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectCalculationsTamSomSamPamChartRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCalculationsTamSomSamPamChartRetrieve(
    params: ProjectCalculationsTamSomSamPamChartRetrieve$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.projectCalculationsTamSomSamPamChartRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }
}
